<template>
  <div>
    <van-nav-bar
      title="智能诊股"
      left-text="返回"
      left-arrow
      @click-left="$router.push('/winners_diagnosis')"
    />
    <van-image :src="require('@/assets/images/bg_01.png')" style="width: 100%; display: block !important;" />
    <van-search
      v-model="search"
      shape="round"
      background="#f7ce00"
      placeholder="输入你要诊断的完整股票/代码"
      @input="fuzzy"
    />
    <van-cell-group>
      <van-cell v-for="(item,index) in searchStock" :key="index" :title="item.name +' '+item.short"
                @click="assignment(item)"/>
    </van-cell-group>
    <van-image :src="require('@/assets/images/banner.jpg')" style="width: 100%; display: block !important;" />
    <div class="main_top">
      <img src="https://cdn.upchina.com/zxjt_stock_diagnosis/StockDiagnosisServerZxjt/img/main_bg.jpg" alt="">
      <p class="p1">市场热度</p>
      <p class="p2">题材透视</p>
      <p class="p3">财务估值</p>
      <p class="p4">主力动向</p>
      <p class="p5">技术趋势</p>
    </div>
<!--    <van-image :src="require('../assets/images/main_bg.jpg')" style="width: 100%;display: block !important;"/>-->
    <van-popup v-model="diagnosisStatus" class="stockPopup" closeable >
      <h3 style="padding-left: 10px">智能诊股</h3>
      <van-row>
        <van-col span="12">
          <div class="stockTitle">
            <h5>{{ stockInfo.name }}</h5>
            <p>{{ stockInfo.code }}</p>
          </div>
        </van-col>
        <van-col span="12">
          <div class="stockTitle">
            <h5 :class="activeColor">{{ stockInfo.price }}&nbsp;<van-icon name="arrow-up"  v-if="activeColor==='red'"/><van-icon name="arrow-down" v-else /></h5>
            <h5 :class="activeColor">{{ stockInfo.pricechange }} {{ stockInfo.changepercent }}%</h5>
            <p> {{ time }}</p>
          </div>
        </van-col>
        <van-col span="6">
          <div class="stockDynamic">
            <h5>今开</h5>
            <p> {{ stockInfo.open }}</p>
          </div>
        </van-col>
        <van-col span="6">
          <div class="stockDynamic">
            <h5>最高</h5>
            <p> {{ stockInfo.high }}</p>
          </div>
        </van-col>
        <van-col span="6">
          <div class="stockDynamic">
            <h5>换手</h5>
            <p> {{ stockInfo.changeHands }}%</p>
          </div>
        </van-col>
        <van-col span="6">
          <div class="stockDynamic">
            <h5>成交量</h5>
            <p> {{ (Number(stockInfo.volume)/1000000).toFixed(2) }}亿</p>
          </div>
        </van-col>
        <van-col span="6">
          <div class="stockDynamic">
            <h5>昨收</h5>
            <p> {{ stockInfo.settlement }}</p>
          </div>
        </van-col>
        <van-col span="6">
          <div class="stockDynamic">
            <h5>最低</h5>
            <p> {{ stockInfo.low }}</p>
          </div>
        </van-col>
        <van-col span="6">
          <div class="stockDynamic">
            <h5>振幅</h5>
            <p> {{ stockInfo.amplitude }}%</p>
          </div>
        </van-col>
        <van-col span="6">
          <div class="stockDynamic">
            <h5>成交额</h5>
            <p> {{ (Number(stockInfo.amount)/10000).toFixed(2) }}亿</p>
          </div>
        </van-col>
        <van-col span="24">
          <div class="stockDiagnosis">
            <van-col span="8">
              <h5>大数据透视：</h5>
            </van-col>
            <van-col span="16">
              <p>{{ stockInfo.statement1 }}</p>
            </van-col>
          </div>
          <div class="stockDiagnosis">
            <van-col span="8">
              <h5>短期阻力位：</h5>
            </van-col>
            <van-col span="16">
              <p>{{ stockInfo.statement2 }}</p>
            </van-col>
          </div>
          <div class="stockDiagnosis">
            <van-col span="8">
              <h5>技术支撑位：</h5>
            </van-col>
            <van-col span="16">
              <p>{{ stockInfo.statement3 }}</p>
            </van-col>
          </div>
          <div class="stockDiagnosis">
            <van-col span="8">
              <h5>主力动态：</h5>
            </van-col>
            <van-col span="16">
              <p>{{ stockInfo.statement4 }}</p>
            </van-col>
          </div>
          <div class="stockDiagnosis">
            <van-col span="8">
              <h5>中期趋势：</h5>
            </van-col>
            <van-col span="16">
              <p>{{ stockInfo.statement5 }}</p>
            </van-col>
          </div>
          <div class="stockDiagnosis">
            <van-col span="8">
              <h5>业绩成长：</h5>
            </van-col>
            <van-col span="16">
              <p>{{ stockInfo.statement6 }}</p>
            </van-col>
          </div>
        </van-col>
        <van-col span="24">
          <p class="control">{{ stockInfo.major_control }}</p>

        </van-col>

      </van-row>
      <div class="kptype" :class="activeClass">

      </div>
    </van-popup>
  </div>
</template>

<script>
  import $ from "jquery";

  export default {
    name: "DiagnosisStock",
    data() {
      return {
        time: '',
        search: '',
        stockList: [],
        searchStock: [],
        diagnosisStatus: false,
        stockInfo: {
          //股票名
          name: '',
          //股票代码
          code: '',
          //价格
          price: '',
          //今开
          open: '',
          //最高
          high: '',
          //换手率
          changeHands: '',
          //成交量
          volume: '',
          //昨收
          settlement: '',
          //最低
          low: '',
          //振幅
          amplitude: '',
          //成交额
          amount: '',
          //涨跌额
          pricechange: '',
          //涨跌幅
          changepercent: '',
          //大数据透视
          statement1: '',
          //短期阻力位
          statement2: '',
          //技术支撑位
          statement3: '',
          //主力动态
          statement4: '',
          //中期趋势
          statement5: '',
          //业绩成长
          statement6: '',
          zlzc: '',
          major_control: '',
          chipPoint: '',

        },
        activeClass: 'none',
        activeColor: 'red'
      }
    },
    methods: {
      loadAll() {
        let that = this;
        that
          .$http({
            url: "/",             //请求地址
            method: "post",
            data: {
              'nozzle': 'all_stock',
            }
          })
          .then(ret => {
            let resData = ret.data;
            that.stockList = resData.data;
          });
      },
      fuzzy(data) {
        let that = this;
        if (data !== '' && data.length >= 2) {
          that.searchStock = that.stockList.filter(item => {
            return item.name.toLowerCase().indexOf(data.toLowerCase()) > -1 || item.short.toLowerCase().indexOf(data.toLowerCase()) > -1 || item.pinyin.toLowerCase().indexOf(data.toLowerCase()) > -1;
          });
        } else {
          that.searchStock = [];
        }
      },
      getTime() {
        let that = this;
        this.timer = setInterval(function () {
          that.time = that.$moment().tz("Asia/Shanghai").format("YYYY-MM-DD HH:mm:ss");
        }, 1000)
      },
      assignment(data) {
        let that = this;
        that.search = data.name;
        that.searchStock = [];
        that.diagnosis(data.short);
      },
      diagnosis(stockCode) {
        let that = this;

        let url = "https://finance.sina.com.cn/tzy/diagnose/" + stockCode + "/app_public.js";
        $.ajax({
          url: url,
          type: "GET",
          dataType: "script",
          cache: true,
          success: function () {
            that.stockInfo.statement1 = diagnose.statement1;
            that.stockInfo.statement2 = diagnose.statement2;
            that.stockInfo.statement3 = diagnose.statement3;
            that.stockInfo.statement4 = diagnose.statement4;
            that.stockInfo.statement5 = diagnose.statement5;
            that.stockInfo.statement6 = diagnose.statement6;
            that.stockInfo.major_control = diagnose.major_control;
            // that.stockInfo.point_ratio = diagnose.point_ratio;
            that.stockInfo.chipPoint = tech.chipPoint;
            that.stockInfo.zlzc = tech.zlzc;
            that.activeClass = that.zlkp(diagnose.point_ratio)
          }
        });
        that.getNewPrice(stockCode);
        that.diagnosisStatus = true;
        clearInterval(that.chatTimer);
        this.chatTimer = setInterval(function () {
          that.getNewPrice(stockCode);
        },1000);
      },
      getNewPrice(stockCode) {
        let that = this;
        $.ajax({
          url: "https://qt.gtimg.cn/q=" + stockCode,
          type: "GET",
          dataType: "script",
          cache: true,
          success: function () {
            var elements = eval("v_" + stockCode).split("~");
            that.stockInfo.name = elements[1];
            that.stockInfo.code = stockCode;
            that.stockInfo.price = elements[3];
            that.stockInfo.open = elements[5];
            that.stockInfo.pricechange = elements[31];
            if (elements[31].substr(0, 1) === '-') {
              that.activeColor = 'green';
            } else {
              that.activeColor = 'red';
            }
            that.stockInfo.changepercent = elements[32];
            that.stockInfo.high = elements[33];
            that.stockInfo.changeHands = elements[38];
            that.stockInfo.volume = elements[36];
            that.stockInfo.settlement = elements[4];
            that.stockInfo.low = elements[34];
            that.stockInfo.amplitude = elements[43];
            that.stockInfo.amount = elements[37];
          }
        });
      },
      zlkp(point) {
        if (point < 20) {
          return 'none';
        } else if (point >= 20 && point < 60) {
          return 'qing';
        } else if (point >= 60 && point < 120) {
          return 'zhong';
        } else {
          return 'gao';
        }
      }
    },
    mounted: function () {
      let that = this;
      this.loadAll();
      that.getTime();
    },
    beforeDestroy() {
      clearInterval(this.timer);
      clearTimeout(this.chatTimer);
    }
  }
</script>

<style scoped>
  .stockPopup {
    width: 90%;
  }

  .stockTitle {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100px;
    border-right: 1px solid #999;
    border-bottom: 1px solid #999;

  }

  .stockTitle h5 {
    margin: 0;
    font-size: 18px;
    line-height: 1.5;
  }

  .stockTitle p {
    margin: 0;
    font-size: 14px;
    line-height: 1.5;
  }

  .stockDynamic {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 50px;
    border-bottom: 1px solid #999;
  }

  .stockDynamic h5 {
    margin: 0;
  }

  .stockDynamic p {
    margin: 0;
  }
  .stockDiagnosis{
    overflow:auto
  }
  .stockDiagnosis h5{
    margin: 0;
    font-size: 14px;
    text-align: right;
  }
  .stockDiagnosis p{
    margin: 0;
    font-size: 14px;
  }
  .control{
    margin: 30px auto;
    font-size: 14px;
    width: 90%;
  }
  .kptype{
    /*margin-top: 30px;*/
    width: 256px;
    height: 146px;
    text-align: center;
    margin: 0 auto;
  }
  .kptype.none {
    background: url("//n.sinaimg.cn/finance/tzy/images/gpzd_main_type.png") no-repeat -20px -20px;
  }

  .kptype.qing {
    background: url("//n.sinaimg.cn/finance/tzy/images/gpzd_main_type.png") no-repeat -295px -20px;
  }

  .kptype.zhong {
    background: url("//n.sinaimg.cn/finance/tzy/images/gpzd_main_type.png") no-repeat -20px -185px;
  }

  .kptype.gao {
    background: url("//n.sinaimg.cn/finance/tzy/images/gpzd_main_type.png") no-repeat -295px -185px;
  }

  .zlwtype.dp {
    background: url("//n.sinaimg.cn/finance/tzy/images/gpzd_support_type.png") no-repeat -20px -20px;
  }

  .zlwtype.qzc {
    background: url("//n.sinaimg.cn/finance/tzy/images/gpzd_support_type.png") no-repeat -306px -20px;
  }

  .zlwtype.rzc {
    background: url("//n.sinaimg.cn/finance/tzy/images/gpzd_support_type.png") no-repeat -592px -20px;
  }

  .zlwtype.zd {
    background: url("//n.sinaimg.cn/finance/tzy/images/gpzd_support_type.png") no-repeat -878px -20px;
  }

  .zlwtype.rzl {
    background: url("//n.sinaimg.cn/finance/tzy/images/gpzd_support_type.png") no-repeat -20px -198px;
  }

  .zlwtype.qzl {
    background: url("//n.sinaimg.cn/finance/tzy/images/gpzd_support_type.png") no-repeat -306px -198px;
  }

  .zlwtype.tp {
    background: url("//n.sinaimg.cn/finance/tzy/images/gpzd_support_type.png") no-repeat -592px -198px;
  }

   .main_top {
    width: 56%;
    /*height: 199px;*/
    background: url(https://cdn.upchina.com/zxjt_stock_diagnosis/StockDiagnosisServerZxjt/img/main_bg.jpg) no-repeat;
    margin: 0 auto;
    background-size: 100%;
    margin: 43px auto 49px;
    position: relative;
  }

   .main_top img {
    width: 100%;
    display: block;
  }

   .main_top p {
    font-size: 12px;
    color: #666;
    line-height: 14px;
    position: absolute;
  }

   .main_top .p1 {
    top: -21px;
    left: 50%;
    margin-left: -24px;
  }

   .main_top .p2 {
    top: 38.5%;
    right: -56px;
    margin-top: -7px;
  }

   .main_top .p3 {
    bottom: -15px;
    right: -17px;
  ;
  }

   .main_top .p4 {
    bottom: -15px;
    left: -17px;
  ;
  }

   .main_top .p5 {
    top: 38.5%;
    left: -56px;
    margin-top: -7px;
  }
  .green{
    color: #008000!important;
  }
  .red {
    color: #ff455e!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/DiagnosisStock.vue